import { render, staticRenderFns } from "./UpdateInventoryDialog.vue?vue&type=template&id=351472e4&scoped=true&"
import script from "./UpdateInventoryDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateInventoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351472e4",
  null
  
)

export default component.exports